import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import styled from "styled-components";

interface FullScreenLoaderContainerProps {
  whiteBg?: boolean;
}

const FullScreenLoaderContainer = styled.div.withConfig({
  shouldForwardProp: (p) => !["whiteBg"].includes(p),
})<FullScreenLoaderContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: ${(props) =>
    props.whiteBg
      ? "color-mix(in srgb, var(--neutral-white) 70%, transparent)"
      : "color-mix(in srgb, var(--palette-common-black) 50%, transparent)"};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  backdrop-filter: blur(2px);
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  color: var(--neutral-white);
  &.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

interface FullScreenLoaderProps {
  isActive?: boolean;
  message?: React.ReactNode;
  whiteBg?: boolean;
  hideIcon?: boolean;
}

function FullScreenLoader({
  isActive,
  message,
  whiteBg = false,
  hideIcon = false,
}: FullScreenLoaderProps) {
  return (
    <FullScreenLoaderContainer
      className={isActive ? "active" : ""}
      whiteBg={whiteBg}
    >
      <div className="d-flex-col-center">
        {!hideIcon && (
          <CircularProgress
            style={{
              color: whiteBg
                ? "var(--primary-base)"
                : "var(--palette-primary-contrastText)",
            }}
            sx={{
              // Use explicit colors to avoid theme dependency
              color: whiteBg
                ? "var(--primary-base)"
                : "var(--palette-primary-contrastText) !important",
              "& .MuiCircularProgress-circle": {
                stroke: whiteBg
                  ? "var(--primary-base)"
                  : "var(--neutral-white) !important",
              },
            }}
          />
        )}
        <Typography
          variant="caption"
          style={{
            color: whiteBg ? "var(--neutral-600)" : "var(--neutral-white)",
          }}
        >
          {message}
        </Typography>
      </div>
    </FullScreenLoaderContainer>
  );
}

export default FullScreenLoader;
